document.addEventListener("keydown", e => {
    if (e.key === "F5" || (e.key.toLowerCase() === "r" && (e.ctrlKey || e.metaKey))) {
        e.preventDefault();
        location.href = location.origin + location.pathname;
    }
});


window.addEventListener('load', function () {
    setTimeout(function () {
        ScrollTrigger.refresh(true);
        
        const wrappers = document.querySelectorAll('#progress-container');

        wrappers.forEach(function (el) {
            el.style.setProperty('visibility', 'visible');
        });
    }, 400);
});

window.addEventListener('load', function () {
    setTimeout(function () {
        document.body.style.setProperty('overflow', 'auto', 'important');
        const menuLinks = document.querySelectorAll('.homepage .header-menu-block a');
        menuLinks.forEach(function (elMenu) {
            elMenu.style.setProperty('pointer-events', 'unset', 'important');
        });

        const hash = window.location.hash;
        if (hash) {
            const target = document.querySelector(hash);
            if (target) {
                const waitForStable = () => {
                    const ready = document.readyState === 'complete';
                    const computedOverflow = window.getComputedStyle(document.body).overflow;
                    if (ready && computedOverflow === 'auto') {
                        ScrollTrigger.refresh(true);
                        setTimeout(() => {
                            const y = target.getBoundingClientRect().top + window.scrollY - 100;
                            window.scrollTo({ top: y, behavior: 'smooth' });
                        }, 200);
                    } else {
                        requestAnimationFrame(waitForStable);
                    }
                };
                waitForStable();
            }
        }
    }, 1600);
});




window.addEventListener('load', function () {

    setTimeout(function () {
        gsap.registerPlugin(ScrollTrigger);

        const container = document.getElementById('progress-container');
        const progressBar = document.getElementById('progress-bar');
        const indicators = document.getElementById('section-indicators');
        const sections = gsap.utils.toArray('.dumbbell-trigger');

        let dots = [];
        const disabledCount = 3;
        const dotHeight = 30;
        const dotGap = 9;
        const spacing = dotHeight + dotGap;

        let dotTops = [];
        let dotCenters = [];

        // Array to store our specific ScrollTriggers
        let progressTriggers = [];

        function debounce(func, wait) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        function createIndicators() {
            indicators.innerHTML = '';
            const totalDots = sections.length + disabledCount;

            for (let i = 0; i < totalDots; i++) {
                const dot = document.createElement('div');
                dot.className = 'dumbbell-dot';
                if (i >= sections.length) dot.classList.add('disabled');
                dot.textContent = `${(i + 1) * 10} KG`;
                indicators.appendChild(dot);
            }

            const allDots = gsap.utils.toArray('#section-indicators .dumbbell-dot');
            dots = allDots.filter(dot => !dot.classList.contains('disabled'));
        }

        function measure() {
            dotTops = dots.map(dot => {
                const rect = dot.getBoundingClientRect();
                const containerRect = container.getBoundingClientRect();
                return rect.top - containerRect.top;
            });
            dotCenters = dotTops.map(top => top + dotHeight / 2);

            gsap.set(progressBar, { height: 0 });
            gsap.set(dots, { y: 0, xPercent: -50 });
        }

        function buildScrollTriggers() {
            // Kill only our specific triggers instead of all
            progressTriggers.forEach(t => t.kill());
            progressTriggers = []; // Reset the array

            sections.forEach((section, i) => {
                const targetHeight = i * spacing + dotHeight / 2;
                const prevHeight = i > 0 ? (i - 1) * spacing + dotHeight / 2 : 0;
                const maxH = dotCenters[i];

                const trigger = ScrollTrigger.create({
                    trigger: section,
                    start: 'top bottom',
                    end: 'top top',
                    scrub: 1.5,
                    invalidateOnRefresh: true,
                    onUpdate: (self) => {
                        const p = self.progress;
                        let height, dotY;

                        if (p < 0.5) {
                            const extendP = p / 0.5;
                            height = gsap.utils.interpolate(prevHeight, maxH, extendP);
                            dotY = 0;
                        } else {
                            const pullP = (p - 0.5) / 0.5;
                            height = gsap.utils.interpolate(maxH, targetHeight, pullP);
                            dotY = height - dotCenters[i];
                        }

                        gsap.to(dots[i], { y: dotY, xPercent: -50, duration: 0.35, ease: "power2.out", overwrite: "auto" });
                        gsap.to(progressBar, { height: height, duration: 0.35, ease: "power2.out", overwrite: "auto" });

                        for (let j = 0; j < i; j++) {
                            const completedTarget = j * spacing + dotHeight / 2;
                            gsap.to(dots[j], { y: completedTarget - dotCenters[j], xPercent: -50, duration: 0.35, ease: "power2.out", overwrite: "auto" });
                        }
                        for (let j = i + 1; j < dots.length; j++) {
                            gsap.to(dots[j], { y: 0, xPercent: -50, duration: 0.35, ease: "power2.out", overwrite: "auto" });
                        }

                        if (p > 0) dots[i].classList.add('active');
                        else dots[i].classList.remove('active');
                    },
                    onEnter: () => dots[i].classList.add("active"),
                    onLeaveBack: () => dots[i].classList.remove("active")
                });

                // Store this trigger
                progressTriggers.push(trigger);
            });

            ScrollTrigger.refresh(true);
        }

        function initAnimations() {
            if (window.innerWidth >= 1200) {
                createIndicators();
                measure();
                buildScrollTriggers();
            } else {
                // Kill only our specific triggers
                progressTriggers.forEach(trigger => trigger.kill());
                progressTriggers = []; // Reset
                indicators.innerHTML = '';
                gsap.set(progressBar, { height: 0 });
            }
        }

        // Initialize animations
        initAnimations();

        const debouncedResize = debounce(() => {
            initAnimations();
        }, 500);

        window.addEventListener('resize', debouncedResize);

        const debouncedObserver = debounce(() => {
            measure();
            ScrollTrigger.refresh(true);
        }, 500);

        if (container) {
            new ResizeObserver(debouncedObserver).observe(container);
        }




        let triggers = [];

        function initScrollTriggers() {
            const cards = gsap.utils.toArray(".better-card");
            const lastCard = cards[cards.length - 1];

            cards.forEach((card, i) => {
                const trigger = gsap.to(card, {
                    scrollTrigger: {
                        trigger: card,
                        start: () => `top-=150 top`,
                        // endTrigger: lastCard,
                        end: () => `top top+=150`,
                        pin: true,
                        pinSpacing: false,
                        scrub: 2,
                        markers: false,
                        invalidateOnRefresh: true
                    }
                });

                triggers.push(trigger.scrollTrigger);
            });
        }

        function killScrollTriggers() {
            triggers.forEach(trigger => trigger.kill());
            triggers = [];
        }

        ScrollTrigger.matchMedia({
            // Only run for screens 1200px and up
            "(min-width: 320px)": function () {
                initScrollTriggers();
            },

            // When going below 1200px, kill triggers
            "(max-width: 319px)": function () {
                killScrollTriggers();
            }
        });


        // Final refresh to ensure everything is perfect
        setTimeout(() => {
            ScrollTrigger.refresh(true);
        }, 100);
    }, 200);
});